export const modalStylesConfig = { content: { padding: 0, width: "400px" } };
export const MODAL_POPUP_HEIGHT = 144;
export const MODAL_BUTTON_WIDTH = "100%";
